<div class="left-modal full">
  <div class="modal-container">
    <div class="L-4 M-4 S-6 centered columns">
      <h1 class="mb-1">{{'Reports' | translate}}</h1>
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        <div class="L-12 M-12 S-12 columns" [ngStyle]="{ 'mb-1': !showChapters }">
          <label>{{'Report' | translate}}**</label>
          <app-dropdown
            [(appModel)]="report_selected"
            (returnObject)="onReportChange($event)"
            [returnObj]="true"
            [value]="'name'"
            [list]="reports"
            [name]="'name'"
          ></app-dropdown>
        </div>
        @if (showChapters) {
          <div class="L-12 M-12 S-12 columns mb-1">
            <label>{{'Chapters' | translate}}</label>
            <app-dropdown
              [(appModel)]="chapterSelected"
              [value]="'id'"
              [multiple]="true"
              [list]="chapters"
              [name]="'chapter_number'"
            ></app-dropdown>
          </div>
        }
        @if (showCategories) {
          <div class="L-12 M-12 S-12 columns mb-1">
            <label>{{'Categories' | translate}}</label>
            <app-dropdown
              [(appModel)]="categoriesSelected"
              [value]="'id'"
              [multiple]="true"
              [list]="categories"
              [name]="'name'"
              [backTranslate]="true"
            ></app-dropdown>
          </div>
        }
        @if (showRange) {
          @if (!showFromTo) {
            <div class="L-12 M-12 S-12 columns">
              <label for="date_from">{{'Date from' | translate}}:</label>
              <input type="date" [(ngModel)]="date_from" name="date_from">
            </div>
          }
          <div class="L-12 M-12 S-12 columns">
            <input type="checkbox" [(ngModel)]="showFromTo" name="showFromTo">
            <p class="checkbox">{{'Show range' | translate}}</p>
          </div>
          @if (showFromTo) {
            <div class="L-6 M-6 S-12 columns mb-1">
              <label for="date_from">{{'Date from' | translate}}</label>
              <input type="date" [(ngModel)]="date_from" name="date_from">
            </div>
            <div class="L-6 M-6 S-12 columns mb-1">
              <label for="date_to">{{'Date to' | translate}}</label>
              <input type="date" [(ngModel)]="date_to" name="date_to">
            </div>
          }
        }
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{'Download report' | translate}}">
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <a class="button cancel" (click)="close($event)">{{'Cancel' | translate}}</a>
        </div>
      </form>
    </div>
  </div>
</div>
